<section class="landing-section">
  <div class="container">
    <div class="hero-card">
     <!--  <div class="hero-brand-logo">
        <img src="/loghi/logo_cooprogetti_padded.png"
             alt="COOPROGETTI Logo"
             class="brand-logo-image"
             loading="lazy"
             decoding="async" />
      </div> -->
      <div class="hero-content">
        <div class="hero-text">
          <h1 class="hero-title">
            Repository di REFERENZE di <br />
            <span class="highlight">COOPROGETTI</span>
          </h1>
          <p class="hero-description">
            <span class="highlight">Referenze</span> è il TOOL dove archiviare, ricercare e condividere
             le <span class="highlight">referenze</span>.
          </p>
          <ul class="hero-features">
            <li>
              <i class="pi pi-check-circle"></i>
              <span>Ricerca veloce tra referenze</span>
            </li>
            <li>
              <i class="pi pi-check-circle"></i>
              <span>Accesso sicuro tramite Auth0</span>
            </li>
            <li>
              <i class="pi pi-check-circle"></i>
              <span>Dati condivisi con l'intera azienda</span>
            </li>
          </ul>
          <div class="hero-actions">
            <button
              pButton
              type="button"
              label="Accedi a Referenze"
              icon="pi pi-arrow-right"
              class="cta-button"
              (click)="login()">
            </button>
          </div>
        </div>
        <div class="hero-visual">
          <div class="visual-icon">
            <img src="/loghi/logo_quadrato.png"
                 alt="Referenze Logo"
                 class="logo-image"
                 />
          </div>
          <p class="visual-description">
            Ottimizza il lavoro di squadra centralizzando le informazioni
            chiave dei progetti.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

